import { getCountry, getLanguage, getLanguageIso2, getMarket, getRegion } from '../modules/i18n';

window.addEventListener('DOMContentLoaded', async () => {
  const endpoint = document.body.dataset.mainMenuEndpoint;
  if (!endpoint) {
    return;
  }

  const navigation = document.querySelector('jb-navigation');
  if (!navigation) {
    return;
  }

  const [country, language, languageIso2, market, region] = await Promise.all([
    getCountry(), getLanguage(), getLanguageIso2(), getMarket(), getRegion(),
  ]);

  const cachedI18n = localStorage.getItem('bjb-fe-mainMenuI18n');
  const currentI18n = JSON.stringify({ country, language, languageIso2, market, region });
  if (cachedI18n !== currentI18n) {
    localStorage.removeItem('bjb-fe-mainMenuData');
    localStorage.removeItem('bjb-fe-mainMenuETag');
  }

  const cachedMenu = localStorage.getItem('bjb-fe-mainMenuData');
  const cachedETag = localStorage.getItem('bjb-fe-mainMenuETag');

  if (cachedMenu) {
    navigation.menu = JSON.parse(cachedMenu);
  }

  const url = endpoint.replace(':marketId', market) + '?L=' + language;
  fetch(url, {
    headers: cachedETag ? { 'If-None-Match': cachedETag } : {}
  })
    .then(response => {
      if (response.status === 304) {
        // Not Modified, use cached data
        return cachedMenu ? JSON.parse(cachedMenu) : null;
      } else if (response.status === 200) {
        // OK, update cache
        const eTag = response.headers.get('ETag');
        return response.json().then(data => {
          if (eTag) {
            localStorage.setItem('bjb-fe-mainMenuETag', eTag);
          }
          localStorage.setItem('bjb-fe-mainMenuData', JSON.stringify(data));
          localStorage.setItem('bjb-fe-mainMenuI18n', currentI18n);
          return data;
        });
      } else {
        throw new Error('Failed to fetch menu data');
      }
    })
    .then(data => {
      if (!data) {
        return;
      }
      navigation.menu = data;
    })
    .catch(error => {
      console.error('Error fetching menu data:', error);
    });
});
